/**
 * Stub CloudflareR2 Service (R2 functionality removed)
 * This file exists only to prevent import errors in components that still reference it
 */

import uploadService from './uploadService';

// Create a stub service that forwards to uploadService
const cloudflareR2Service = {
  isConfigured() {
    console.warn('CloudflareR2 service has been removed. Using uploadService instead.');
    return uploadService.isConfigured();
  },

  generateFileName(originalName) {
    return uploadService.generateFileName(originalName);
  },

  uploadFile(file, onProgress = null) {
    console.warn('CloudflareR2 service has been removed. Using uploadService instead.');
    return uploadService.uploadWithValidation(file, onProgress);
  },

  validateFileType(file) {
    return uploadService.validateFileType(file);
  },

  uploadWithValidation(file, onProgress = null) {
    console.warn('CloudflareR2 service has been removed. Using uploadService instead.');
    return uploadService.uploadWithValidation(file, onProgress);
  }
};

export default cloudflareR2Service; 